import React, { useState, useEffect } from 'react';
import { fetchGeofences } from '../../services/api/geofenceApi';
import { fetchStageList } from '../../services/ResultsApi';
import './Splits/AdminSplits.css'; // Re-use styles for now

const AdminSplitList = () => {
    const [geofences, setGeofences] = useState([]);
    const [stages, setStages] = useState([]);
    const [loading, setLoading] = useState(false);
    const [competitionId, setCompetitionId] = useState(localStorage.getItem('admin_competition_id') || '');

    useEffect(() => {
        loadData();
    }, [competitionId]); // Reload when competitionId changes

    const loadData = async () => {
        setLoading(true);
        try {
            // Load Geofences
            const allGeofences = await fetchGeofences();
            // Filter for 'SPLIT' type
            const splitGeofences = allGeofences.filter(gf =>
                gf.attributes && gf.attributes.pointType === 'SPLIT'
            );
            setGeofences(splitGeofences);

            // Load Stages if ID provided
            if (competitionId) {
                const stageList = await fetchStageList(competitionId);
                setStages(Array.isArray(stageList) ? stageList : []);
            }
        } catch (error) {
            console.error("Failed to load data:", error);
        } finally {
            setLoading(false);
        }
    };

    const handleCompetitionIdChange = (e) => {
        const newVal = e.target.value;
        setCompetitionId(newVal);
        localStorage.setItem('admin_competition_id', newVal);
    };

    // Group geofences by stageId
    const groupedSplits = geofences.reduce((acc, gf) => {
        const stageId = gf.attributes.stageId || 'Unassigned';
        if (!acc[stageId]) acc[stageId] = [];
        acc[stageId].push(gf);
        return acc;
    }, {});

    // Sort groups by stageId (maybe?) and items by orderNo
    Object.keys(groupedSplits).forEach(key => {
        groupedSplits[key].sort((a, b) => {
            const orderA = parseInt(a.attributes.orderNo) || 999;
            const orderB = parseInt(b.attributes.orderNo) || 999;
            return orderA - orderB;
        });
    });

    const getStageName = (id) => {
        if (id === 'Unassigned') return 'Unassigned';
        const stage = stages.find(s => String(s.ID) === String(id));
        return stage ? stage.Name : `Stage ${id}`;
    };

    return (
        <div className="admin-splits-container" style={{ display: 'block', padding: '20px', overflowY: 'auto' }}>
            <div className="card">
                <div className="card-header" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <h2 className="card-title">Split List</h2>
                    <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
                        <label className="label" style={{ margin: 0 }}>Competition ID:</label>
                        <input
                            type="text"
                            className="input"
                            style={{ width: '100px' }}
                            value={competitionId}
                            onChange={handleCompetitionIdChange}
                            placeholder="ex. 1"
                        />
                        <button className="btn btn-primary" onClick={loadData}>Refresh</button>
                    </div>
                </div>

                {loading ? (
                    <div className="loading-spinner">Loading...</div>
                ) : (
                    <div className="splits-groups">
                        {Object.keys(groupedSplits).sort().map(stageId => (
                            <div key={stageId} className="stage-group" style={{ marginBottom: '20px', border: '1px solid #eee', borderRadius: '8px', padding: '15px' }}>
                                <h3 style={{ fontSize: '1.2rem', marginBottom: '10px', borderBottom: '2px solid var(--primary-color)', paddingBottom: '5px' }}>
                                    {getStageName(stageId)} <span style={{ fontSize: '0.8rem', color: '#888' }}>(ID: {stageId})</span>
                                </h3>
                                <table className="table is-fullwidth is-striped">
                                    <thead>
                                        <tr>
                                            <th>Order</th>
                                            <th>Name</th>
                                            <th>Description</th>
                                            <th>Coordinates</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {groupedSplits[stageId].map(gf => (
                                            <tr key={gf.id}>
                                                <td>{gf.attributes.orderNo || '-'}</td>
                                                <td>{gf.name}</td>
                                                <td>{gf.description}</td>
                                                <td style={{ fontSize: '0.8rem', fontFamily: 'monospace' }}>{gf.area}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        ))}
                        {geofences.length === 0 && <p>No SPLIT geofences found.</p>}
                    </div>
                )}
            </div>
        </div>
    );
};

export default AdminSplitList;
